import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      title: "Politique de Confidentialité",
      lastUpdated: "Dernière mise à jour : 5 juin 2024",
      sections: [
        {
          title: "1. Introduction",
          content: "Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos données personnelles lorsque vous utilisez notre site web."
        },
        {
          title: "2. Données collectées",
          content: "Nous collectons les données suivantes :",
          list: [
            "Données de navigation (adresse IP, pages visitées)",
            "Cookies et technologies similaires",
            "Informations que vous nous fournissez via les formulaires",
            "Données d'analyse de l'utilisation du site"
          ]
        },
        {
          title: "3. Utilisation des données",
          content: "Vos données sont utilisées pour :",
          list: [
            "Améliorer votre expérience utilisateur",
            "Analyser et optimiser notre site",
            "Vous contacter si nécessaire",
            "Respecter nos obligations légales"
          ]
        },
        {
          title: "4. Cookies",
          content: "Nous utilisons des cookies pour :",
          list: [
            "Assurer le bon fonctionnement du site",
            "Analyser le trafic et l'utilisation",
            "Personnaliser votre expérience",
            "Mémoriser vos préférences"
          ]
        },
        {
          title: "5. Vos droits",
          content: "Conformément au RGPD, vous disposez des droits suivants :",
          list: [
            "Droit d'accès à vos données",
            "Droit de rectification",
            "Droit à l'effacement",
            "Droit à la limitation du traitement",
            "Droit à la portabilité des données",
            "Droit d'opposition"
          ]
        },
        {
          title: "6. Sécurité",
          content: "Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données contre tout accès, modification, divulgation ou destruction non autorisés."
        },
        {
          title: "7. Contact",
          content: "Pour toute question concernant cette politique ou pour exercer vos droits, contactez-nous à : privacy@julycia.com"
        }
      ]
    },
    en: {
      title: "Privacy Policy",
      lastUpdated: "Last updated: June 5, 2024",
      sections: [
        {
          title: "1. Introduction",
          content: "This privacy policy describes how we collect, use, and protect your personal data when you use our website."
        },
        {
          title: "2. Data Collection",
          content: "We collect the following data:",
          list: [
            "Browsing data (IP address, pages visited)",
            "Cookies and similar technologies",
            "Information you provide through forms",
            "Website usage analytics data"
          ]
        },
        {
          title: "3. Data Usage",
          content: "Your data is used to:",
          list: [
            "Improve your user experience",
            "Analyze and optimize our website",
            "Contact you when necessary",
            "Comply with legal obligations"
          ]
        },
        {
          title: "4. Cookies",
          content: "We use cookies to:",
          list: [
            "Ensure proper website functionality",
            "Analyze traffic and usage",
            "Personalize your experience",
            "Remember your preferences"
          ]
        },
        {
          title: "5. Your Rights",
          content: "Under GDPR, you have the following rights:",
          list: [
            "Right to access your data",
            "Right to rectification",
            "Right to erasure",
            "Right to restrict processing",
            "Right to data portability",
            "Right to object"
          ]
        },
        {
          title: "6. Security",
          content: "We implement appropriate security measures to protect your data against unauthorized access, modification, disclosure, or destruction."
        },
        {
          title: "7. Contact",
          content: "For any questions about this policy or to exercise your rights, contact us at: privacy@julycia.com"
        }
      ]
    }
  };

  return (
    <>
      <Header />
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {content[language].title}
            </h1>
            <p className="text-gray-600 mb-8">
              {content[language].lastUpdated}
            </p>

            <div className="space-y-8">
              {content[language].sections.map((section, index) => (
                <section key={index} className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    {section.title}
                  </h2>
                  <p className="text-gray-600 mb-4">
                    {section.content}
                  </p>
                  {section.list && (
                    <ul className="list-disc list-inside space-y-2 text-gray-600">
                      {section.list.map((item, i) => (
                        <li key={i} className="ml-4">{item}</li>
                      ))}
                    </ul>
                  )}
                </section>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage; 